import { makeStyles } from '@material-ui/core/styles'

// Mirrors the Amplify UI section/form theme the auth screens used before the v6 upgrade, so sign in,
// forgot password and new password keep the look that is live on production.
export const useAuthScreenStyles = makeStyles({
  page: {
    display: 'flex',
    justifyContent: 'center',
    padding: '64px 20px',
  },
  card: {
    width: '100%',
    maxWidth: 460,
    boxSizing: 'border-box',
    padding: '35px 40px',
    backgroundColor: '#fff',
    border: '1px solid #e9e9e9',
    borderRadius: 6,
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.08)',
  },
  logo: {
    display: 'block',
    width: 122,
    marginBottom: 10,
  },
  header: {
    margin: '0 0 24px',
    color: '#152939',
    fontSize: 18,
    fontWeight: 400,
    lineHeight: 1.4,
  },
  field: {
    marginBottom: 24,
  },
  label: {
    display: 'block',
    marginBottom: 8,
    color: '#152939',
    fontSize: 14,
  },
  input: {
    width: '100%',
    boxSizing: 'border-box',
    padding: 16,
    color: '#152939',
    fontSize: 14,
    lineHeight: 1,
    fontFamily: 'inherit',
    border: '1px solid #c4c4c4',
    borderRadius: 3,
    backgroundColor: '#fff',
    '&:focus': {
      outline: 'none',
      borderColor: '#ff9900',
    },
  },
  hint: {
    margin: '8px 0 0',
    color: '#828282',
    fontSize: 12,
  },
  link: {
    padding: 0,
    border: 'none',
    background: 'none',
    color: '#ff9900',
    fontSize: 'inherit',
    fontFamily: 'inherit',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  error: {
    margin: '0 0 16px',
    color: '#d0021b',
    fontSize: 13,
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 20,
  },
  footerSecondary: {
    marginRight: 'auto',
    color: '#828282',
    fontSize: 14,
  },
  submit: {
    minWidth: 153,
    padding: '14px 0',
    border: 'none',
    borderRadius: 3,
    backgroundColor: '#ff9900',
    color: '#fff',
    fontSize: 13,
    lineHeight: 1.2,
    fontFamily: 'inherit',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    cursor: 'pointer',
    '&:disabled': {
      opacity: 0.6,
      cursor: 'default',
    },
  },
})
